import React, { useState } from 'react'
import PromptTab from './PromptTab'
import SliderViewMobile from './SliderViewMobile'
import SliderViewDesktop from './SliderViewDesktop'
import { useSelector } from 'react-redux'

const PromptSelection = ({
  option1,
  isMobile,
  handleSelectedOptionChange = {},
  selectedParameters,
  containerClassName = '',
}) => {
  const { textToImagePrompts, tabOptions } = useSelector((state) => state.prompt)
  const [selectedOption1, setSelectedOption1] = useState(tabOptions ? tabOptions[0] : null)

  return (
    <div className="flex flex-col justify-between items-center mt-3 h-full md:mt-0">
      {isMobile && (
        <PromptTab option1={option1} setSelectedOption1={setSelectedOption1} selectedOption1={selectedOption1} />
      )}

      <div className={`w-full ${containerClassName}`}>
        {isMobile && (
          <SliderViewMobile
            selectedOption1={selectedOption1}
            handleSelectedOptionChange={handleSelectedOptionChange}
            selectedParameters={selectedParameters}
          />
        )}
        {!isMobile && (
          <div className="flex flex-col gap-2 mt-4">
            {Object.keys(textToImagePrompts || {})?.map((categoryKey) => (
              <>
                <h3 className="mt-2 mb-1 text-xl font-black text-black capitalize">{categoryKey}</h3>
                <SliderViewDesktop
                  handleSelectedOptionChange={handleSelectedOptionChange}
                  selectedParameters={selectedParameters}
                  categoryKey={categoryKey}
                />
              </>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default PromptSelection
